import { Input } from '@breetometer/components';
import { CopyIcon, QrIcon } from 'BreetAssets';
import { alwaysRefetchApiQueryOptions, copyToClipboard, type IDropDownItem } from 'BreetHelpers';
import { useModalApi } from 'BreetHooks';
import { useGetSellAssetsQuery } from 'BreetRedux';
import { type MouseEvent, useCallback, useMemo, useState } from 'react';

import DropDown from '@/components/Dropdown/Dropdown';

import DropdownItemAssets from './DropdownItemAssets';

const CryptoFundingMethod = () => {
	const [coin, setCoin] = useState<IDropDownItem | undefined>();

	const { handleOpenModal } = useModalApi();

	const { data: tradeSellAssetsData } = useGetSellAssetsQuery(undefined, alwaysRefetchApiQueryOptions);

	const sellAssetItems = useMemo(
		() =>
			tradeSellAssetsData?.data
				// ?.sort(sortTradeAssets)
				// .filter(filterAssetItem)
				// .filter(filterAssetItemSymbol('USDC'))
				// .filter(filterAssetItemSymbol('USDT'))
				?.map((i) => ({
					code: i.name,
					icon: i.avatar,
					name: i.identifier,
					value: i.name,
				})) ?? [],
		[tradeSellAssetsData?.data]
	);

	const handleItemSelect = useCallback(
		(item: IDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => {
			e.preventDefault();
			setCoin(item);
		},
		[]
	);

	const walletAddress = useMemo(
		() => tradeSellAssetsData?.data?.find((i) => i.name === coin?.value)?.wallet?.address ?? '',
		[tradeSellAssetsData?.data, coin]
	);

	return (
		<div className='new-drop-down-input crypto-fund-method'>
			<DropDown.Default
				items={sellAssetItems}
				placeholder='Select Coin'
				label='Select Coin'
				iconAs='image'
				id='select-funding-method'
				selectedItem={coin}
				CustomItemOption={DropdownItemAssets}
				handleItemSelect={handleItemSelect}
			/>

			{!!coin?.value && (
				<div className='wallet-address-value'>
					<Input
						label='Wallet Address'
						id='addresses'
						widthType='full'
						value={walletAddress}
					/>

					<div className='icon-wrapper'>
						<CopyIcon
							variant='plain'
							className='copy-icon svg-dark'
							focusable
							onClick={copyToClipboard(walletAddress, 'Wallet address copied')}
						/>

						<QrIcon
							className='qr-icon svg-dark'
							focusable
							onClick={handleOpenModal({ id: 'qrCode', metadata: { url: walletAddress }, hideCloseButton: true })}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default CryptoFundingMethod;
